import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core'
import PlaceIcon from '@material-ui/icons/Place'

import { EditIcon } from 'src/components/atoms/Icons'
import { RemoveIconButton } from 'src/components/atoms/RemoveButton'
import { formatTideRateDataRange } from 'src/utils/formatters'

const StyledList = styled(List)`
  && {
    padding-bottom: 0;
    padding-top: 0;
  }
`

const StyledListItem = styled(ListItem)`
  && {
    padding: ${({ theme }) => theme.spacing(1, 0)};
  }
`

const StyledListItemSecondaryAction = styled(ListItemSecondaryAction)`
  && {
    display: flex;
  }
`

const DateRangeDescription = styled.span`
  display: inline-block;
  width: 100px;
`

const TideRateStationItem = ({ station, onUpload, onClick, onRemove, className, selectedStyle }) => {
  const { uuid, name, dateRange = [], metadata } = station

  const dateRangeAll = dateRange[0]
  const { start: firstDateAll, end: lastDateAll } = dateRangeAll || {}

  const handleRemoveClick = useCallback(
    (event) => {
      event.stopPropagation()
      if (onRemove) {
        onRemove(uuid)
      }
    },
    [onRemove, uuid]
  )
  const handleUploadClick = useCallback(
    (event) => {
      event.stopPropagation()
      if (onUpload) {
        onUpload(uuid)
      }
    },
    [onUpload, uuid]
  )
  const handleOnClick = useCallback(() => {
    if (onClick) {
      onClick(uuid)
    }
  }, [onClick, uuid])

  return (
    <StyledListItem button onClick={handleOnClick} className={className} style={selectedStyle}>
      <ListItemIcon>
        <PlaceIcon color={metadata && metadata.enabled ? 'primary' : 'action'} />
      </ListItemIcon>
      <ListItemText
        primary={name}
        secondary={
          <>
            <DateRangeDescription>Tide rate data: </DateRangeDescription>
            {formatTideRateDataRange(firstDateAll, lastDateAll)}
          </>
        }
      />
      <StyledListItemSecondaryAction>
        <IconButton onClick={handleUploadClick}>
          <EditIcon />
        </IconButton>
        <RemoveIconButton onClick={handleRemoveClick} />
      </StyledListItemSecondaryAction>
    </StyledListItem>
  )
}

TideRateStationItem.propTypes = {
  station: PropTypes.any,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  onUpload: PropTypes.func,
  className: PropTypes.string,
  selectedStyle: PropTypes.any
}

export const TideRateStationList = ({
  data = [],
  selectedTideRateStation,
  onUpload,
  onClick,
  onRemove,
  ...listProp
}) => {
  return (
    <StyledList {...listProp}>
      {data.map((item) => {
        let selectedStyle
        if (selectedTideRateStation && selectedTideRateStation.uuid === item.uuid) {
          selectedStyle = {
            border: '1px solid #C5D0DE'
          }
        }
        return (
          <TideRateStationItem
            key={item.uuid}
            station={item}
            onRemove={onRemove}
            onClick={onClick}
            onUpload={onUpload}
            selectedStyle={selectedStyle}
          />
        )
      }
      )}
    </StyledList>
  )
}

TideRateStationList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      uuid: PropTypes.string,
    })
  ),
  selectedTideRateStation: PropTypes.any,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  onUpload: PropTypes.func,
}

export default TideRateStationList
